import AssistantTypingLoader from "./AssistantTypingLoader";

import "./AssistantTypingLoader.scss";

export { AssistantTypingLoader };
